import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



const cardData = {
  keyword: "Ertiga On Rent in Pune",
  heading: "Lotus Cab: Ertiga On Rent in Pune",

  headingDescription:
    "Lotus Cabs offers affordable and comfortable Ertiga On Rent in Pune for airport transfers, outstation trips, family vacations, corporate travel, wedding transportation, sightseeing tours, pilgrimage journeys, and one-way or round-trip bookings. The Maruti Suzuki Ertiga is an excellent choice for families and small groups, offering spacious seating, modern features, generous luggage space, and a smooth ride for both city and highway travel. Driven by professional and experienced chauffeurs, our well-maintained Ertiga cabs ensure safe, reliable, and hassle-free travel. With 24x7 booking assistance, transparent pricing, doorstep pickup across Pune, and exceptional customer support, Lotus Cabs delivers a premium travel experience at an economical price.",


  top: "Top Places to Visit in Pune with Ertiga Rental",

 topPlaces: [
 
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the nearest and most frequently visited weekend destinations from Pune. Famous for Bhushi Dam, Tiger Point, Rajmachi Fort, and Karla Caves, it is an excellent choice for day trips and family outings. The Ertiga provides ample comfort and space for sightseeing and short vacations."
    },
    {
        title: "Goa",
        description:
            "Goa is a preferred destination for beach holidays, group vacations, and long road trips from Pune. Renting an Ertiga offers a perfect combination of affordability, spacious seating, fuel efficiency, and luggage capacity, making it ideal for exploring North and South Goa comfortably."
    },
    {
        title: "Nashik",
        description:
            "Nashik is well known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and religious tourism. Travelers frequently rent an Ertiga from Pune for family pilgrimages, wine tours, and sightseeing while enjoying a comfortable highway journey with plenty of room for passengers and luggage."
    },
       {
        title: "Mumbai",
        description:
            "Mumbai is one of the most popular destinations for travelers booking an Ertiga from Pune. Whether you are heading to Mumbai International Airport, attending corporate meetings, visiting family, exploring famous attractions, or planning a weekend getaway, the spacious and comfortable Ertiga provides a smooth journey for families, business travelers, and small groups."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of Maharashtra's most important pilgrimage destinations and attracts devotees throughout the year for Sai Baba Darshan. Renting an Ertiga from Pune is an ideal option for families and senior citizens, offering comfortable seating, sufficient luggage space, and a relaxed journey for religious tours."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a favorite hill station known for its strawberry farms, Venna Lake, scenic viewpoints, pleasant climate, and lush green valleys. The Ertiga is well suited for hill station travel, allowing families and groups to enjoy a comfortable and enjoyable road trip from Pune."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for the Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian cuisine. The Ertiga is an excellent vehicle for families visiting the city for pilgrimage, cultural tours, or business travel, providing a relaxed and convenient travel experience."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad, officially Chhatrapati Sambhajinagar, is renowned for the UNESCO-listed Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, and historical monuments. Renting an Ertiga from Pune allows travelers to comfortably explore the city's rich heritage while enjoying a spacious and reliable vehicle."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a scenic coastal destination famous for its beaches, sea forts, water sports, and luxury resorts. Families and groups often choose an Ertiga on rent from Pune for weekend escapes, thanks to its comfortable seating, smooth performance, and generous luggage capacity."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas and a popular pilgrimage destination nestled in the Sahyadri Hills. Renting an Ertiga from Pune provides devotees with a comfortable and dependable travel option, making the journey through the scenic mountain roads both safe and enjoyable."
    }
],

  services: [
    {
      name: "Maruti Suzuki Ertiga On Rent in Pune",
      description:
        "Book Maruti Suzuki Ertiga on rent in Pune for spacious and comfortable 7-seater travel. Ideal for family trips, airport transfers, and outstation journeys. The vehicle offers ample legroom, luggage space, and smooth suspension for city and highway travel. Fully air-conditioned interiors ensure comfort during all seasons. Professional chauffeur included with transparent per-km pricing and flexible booking options."
    },
    {
      name: "Ertiga Taxi Pune",
      description:
        "Ertiga taxi service in Pune is suitable for daily commuting and small group travel. Spacious seating and comfortable interiors provide relaxed travel experience. AC vehicle with professional driver ensures safe and smooth ride."
    },
    {
      name: "Ertiga for Outstation Pune",
      description:
        "Reliable Ertiga outstation cab service from Pune to major cities and tourist destinations. Stable highway performance and luggage capacity make it ideal for long-distance travel. Flexible one-way and round-trip options available."
    },
    {
      name: "Ertiga Airport Cab Pune",
      description:
        "Punctual Ertiga airport pickup and drop service with luggage support. Ideal for family airport transfers with comfortable AC interiors."
    },
    {
      name: "Affordable Ertiga Rental Pune",
      description:
        "Budget-friendly Ertiga rental with transparent pricing and no hidden charges. Suitable for daily rides and short trips."
    },
    {
      name: "7 Seater Ertiga Pune",
      description:
        "Comfortable 7-seater MPV ideal for family group travel. Spacious cabin ensures relaxed seating arrangement."
    },
    {
      name: "Corporate Cab Ertiga Pune",
      description:
        "Professional Ertiga service for corporate meetings and staff transport. Clean interiors and punctual service guaranteed."
    },
    {
      name: "Online Ertiga Booking Pune",
      description:
        "Instant online booking with quick confirmation and 24/7 customer support assistance."
    }
  ],

  tableData: [
    ["Ertiga On Rent in Pune", "Maruti Suzuki Ertiga On Rent in Pune"],
    ["Ertiga Taxi Pune", "Ertiga for Outstation Pune"],
    ["Ertiga Airport Cab Pune", "Affordable Ertiga Rental Pune"],
    ["7 Seater Ertiga Pune", "Ertiga Per Km Rate Pune"],
    ["AC Ertiga Taxi Pune", "Chauffeur Driven Ertiga Pune"],
    ["Family Trip Ertiga Pune", "Corporate Cab Ertiga Pune"],
    ["Online Ertiga Booking Pune", ""]
  ],

  whychoose: [
    { WhyChooseheading: "Spacious 7-Seater Comfort", WhyChoosedescription: "Ertiga offers ample seating and legroom for families and small groups ensuring relaxed travel experience." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Trained and experienced drivers ensure safe, punctual, and smooth journey." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare structure with no hidden charges." },
    { WhyChooseheading: "AC Comfort All Seasons", WhyChoosedescription: "Fully air-conditioned interiors provide comfort during summer and long trips." },
    { WhyChooseheading: "Flexible Travel Packages", WhyChoosedescription: "One-way, round-trip, and hourly rental packages available." },
    { WhyChooseheading: "Ideal for Family Trips", WhyChoosedescription: "Perfect vehicle for weekend getaways and outstation tours." },
    { WhyChooseheading: "Well-Maintained Vehicles", WhyChoosedescription: "Regularly serviced and sanitized vehicles ensure safety and hygiene." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock assistance available for booking and travel coordination." }
  ]
};

const faqData = [
  { question: "Is Ertiga suitable for family trips?", answer: "Yes, Ertiga is a spacious 7-seater ideal for comfortable family travel with luggage support." },
  { question: "Is driver included?", answer: "Yes, all Ertiga rentals are chauffeur-driven by professional drivers." },
  { question: "Is airport transfer available?", answer: "Yes, AC Ertiga airport pickup and drop service is available." },
  { question: "Is outstation booking allowed?", answer: "Yes, Ertiga available for long-distance outstation travel." },
  { question: "Is pricing per km transparent?", answer: "Yes, we provide clear per-km pricing with no hidden charges." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with quick confirmation." },
  { question: "Is vehicle sanitized?", answer: "Yes, regularly cleaned and maintained before every trip." },
  { question: "Is corporate booking available?", answer: "Yes, corporate Ertiga rental services are available." },
  { question: "Is AC available?", answer: "Yes, fully air-conditioned Ertiga vehicles provided." },
  { question: "Is 24/7 support available?", answer: "Yes, customer support available anytime." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Booked Ertiga for family trip to Mahabaleshwar. Spacious seating, smooth ride, and professional driver made our journey comfortable and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Deshmukh",
    feedback:
      "Used Ertiga for airport transfer with family. Plenty of luggage space and punctual service. Very reliable and affordable.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Excellent Ertiga service for business travel. Clean vehicle, professional driver, and transparent pricing.",
    rating: 5
  }
];













































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Ertiga on Rent in Pune",
"image": "https://lotuscab.com/assets/images/ertiga-on-rent-pune.jpg",
"description": "Book Ertiga on Rent in Pune with Lotus Cab for comfortable, spacious, and affordable travel. Ideal for family trips, airport transfers, weddings, and outstation journeys. 6–7 seater AC SUV available 24x7 with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7342"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹15/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/ertiga-on-rent-pune"
}
};












  return (
    <div>
      

<Helmet>
  <title>Ertiga on Rent in Pune | 6–7 Seater SUV Cab Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Ertiga on Rent in Pune with Lotus Cab for safe and comfortable travel. 6–7 seater SUV cab for airport transfers, outstation trips, and family travel. Affordable rates, AC comfort, and 24x7 service."
/>

<meta
 name="keywords"
 content="Ertiga on Rent in Pune, Ertiga Cab Pune, Pune Ertiga Rental, Ertiga Taxi Pune, 7 Seater Cab Pune, SUV Cab Pune, Innova Alternative Pune, Outstation Ertiga Cab Pune, Airport Ertiga Cab Pune, Family Cab Pune, Affordable Ertiga Cab Pune, Cheap Ertiga Rental Pune, Online Ertiga Cab Booking Pune, Lotus Cab Pune Ertiga, Hire Ertiga Pune, AC SUV Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinpune;